import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveProject: ['project', 'onSuccess', 'onError'],
  toggleArchiveProject: ['project', 'onSuccess', 'onError'],
  projectError: ['error']
})

const saveProject = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const toggleArchiveProject = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const projectError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.PROJECT_ERROR]: projectError,

  [Types.SAVE_PROJECT]: saveProject,
  [Types.TOGGLE_ARCHIVE_PROJECT]: toggleArchiveProject,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ProjectTypes,
  Creators as ProjectActions
}
